function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 410 410",
    style: {
      enableBackground: "new 0 0 410 410"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "XMLID_1256_"
  }, React.createElement("polygon", {
    id: "XMLID_1257_",
    style: {
      fill: "#D80027"
    },
    points: "345.01,207.769 345.01,207.77 250,297.5 385,410 385,170  "
  }), React.createElement("polygon", {
    id: "XMLID_1258_",
    style: {
      fill: "#FF5023"
    },
    points: "25,170 25,410 160,297.5  "
  }), React.createElement("polygon", {
    id: "XMLID_1259_",
    style: {
      fill: "#D80027"
    },
    points: "160,297.5 25,410 205,410 205,340  "
  }), React.createElement("polygon", {
    id: "XMLID_1260_",
    style: {
      fill: "#A2001D"
    },
    points: "205,340 205,410 385,410 250,297.5  "
  }), React.createElement("polygon", {
    id: "XMLID_1261_",
    style: {
      fill: "#FF5023"
    },
    points: "64.993,132.229 25,170 64.99,170  "
  }), React.createElement("polygon", {
    id: "XMLID_1262_",
    style: {
      fill: "#FF5023"
    },
    points: "385,170 345.005,132.227 345.008,170  "
  }), React.createElement("polygon", {
    id: "XMLID_1263_",
    style: {
      fill: "#FF5023"
    },
    points: "205,0 141.213,60.243 268.626,60.092  "
  }), React.createElement("polygon", {
    id: "XMLID_1264_",
    style: {
      fill: "#A2001D"
    },
    points: "345.01,207.769 385,170 345.008,170  "
  }), React.createElement("polygon", {
    id: "XMLID_1265_",
    style: {
      fill: "#A2001D"
    },
    points: "205,340 64.986,207.765 64.99,170 25,170 160,297.5  "
  }), React.createElement("path", {
    id: "XMLID_1266_",
    style: {
      fill: "#DEDDE0"
    },
    d: "M64.986,207.765L205,340l45-42.5l95.01-89.73v-0.001L345.008,170l-0.003-37.773 L345,60l-76.374,0.092l-127.413,0.151L65,60.334l-0.007,71.895L64.99,170L64.986,207.765z M115,180h180v30H115V180z M115,150v-30 h180v30H115z"
  }), React.createElement("rect", {
    id: "XMLID_1270_",
    x: 115,
    y: 120,
    style: {
      fill: "#FFFFFF"
    },
    width: 180,
    height: 30
  }), React.createElement("rect", {
    id: "XMLID_1271_",
    x: 115,
    y: 180,
    style: {
      fill: "#FFFFFF"
    },
    width: 180,
    height: 30
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.89a56da3.svg";
export { ForwardRef as ReactComponent };